import {
    group
} from "@/mixin/group";

export const mixinClassify = {
    mixins: [group],
    created() {
        this.$store.dispatch("classifyList");
        if (this.classifyList && this.classifyList.length) {
            this.initGroup();
        }
    },
    computed: {
        classifyList() {
            return this.$store.state.classifyList;
        }
    },
    watch: {
        classifyList(v) {
            // console.log(v);
            // DOM已经更新
            this.initGroup();
        }
    }
}